import { Auth0Config } from '../types';

/**
 * Default Auth0 configuration from environment variables.
 * This function centralizes the configuration retrieval.
 */
const missingEnv = [
    import.meta.env.VITE_AUTH0_DOMAIN,
    import.meta.env.VITE_AUTH0_CLIENT_ID,
    import.meta.env.VITE_AUTH0_AUDIENCE,
].some((val): boolean => !val);

if (missingEnv) {
    throw new Error(
        'Missing required environment variables: VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID, VITE_AUTH0_AUDIENCE',
    );
}

export const getDefaultAuth0Config = (): Auth0Config => ({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
        redirect_uri: `${typeof window !== 'undefined' ? window.location.origin : ''}/`,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
    },
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    useRefreshTokensFallback: true,
});

/**
 * Merges default configuration with overrides.
 * @param overrides - Partial configuration to override defaults
 * @returns Complete Auth0 configuration
 */
export const getAuth0Config = (
    overrides?: Partial<Auth0Config>,
): Auth0Config => {
    const defaultConfig = getDefaultAuth0Config();
    return { ...defaultConfig, ...overrides };
};
